import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from './lib/queryClient';
import { router } from './router';
import { ThemeProvider } from './contexts/ThemeContext';
import { LayoutProvider } from './contexts/LayoutContext';
import { ErrorProvider } from './contexts/ErrorContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastContainer } from './components/ui/ToastContainer';
import './index.css';

// Log version on startup
console.log(`Shipcast Frontend ${__APP_VERSION__}`);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <ErrorProvider>
        <ToastContainer />
        <ErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <LayoutProvider>
              <RouterProvider router={router} context={{ queryClient }} />
            </LayoutProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </ErrorProvider>
    </ThemeProvider>
  </StrictMode>,
);
